var _path, _path2, _path3, _path4, _circle, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0477 24.0448C63.9112 13.8989 26.1335 11.5243 20.7367 19.2956L18.3621 31.9139L26.7811 38.8218L40.8128 42.4917L55.0604 39.2536L65.6382 29.971L63.0477 24.0448Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6573 20.9048C18.7938 31.2667 30.2351 37.7429 42.9716 39.6857L41.8922 44.6508C27.6446 44.4349 20.5208 42.0603 16.4192 28.8921C16.8868 25.8588 17.4183 24.1293 19.6573 20.9048Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0285 39.2536C38.0545 40.7649 37.4706 41.7175 37.1428 44.8663C55.1371 44.6597 60.4478 42.3473 66.2857 30.9528C65.351 27.9653 65.4093 25.7121 63.2634 23.4949C60.4092 34.2573 55.0612 37.5105 41.0285 39.2536Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4636 30.0889C24.6602 24.3323 56.5109 24.3323 60.0255 30.0889",
    stroke: "#999999",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.46,
    cy: 42.2757,
    r: 1.29524,
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4191 28.7939C11.5326 30.5677 8.81525 31.1421 3.89844 31.3844",
    stroke: "#999999",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5018 30.9524C70.2088 32.4306 72.2702 32.9092 76.0002 33.1111",
    stroke: "#999999",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandUp);
export default __webpack_public_path__ + "static/media/stand_up.fa8906365c41fb7cd2c93a976ac16167.svg";
export { ForwardRef as ReactComponent };